import { render, staticRenderFns } from "./top-shareholders.vue?vue&type=template&id=a42c57a2"
import script from "./top-shareholders.vue?vue&type=script&lang=js"
export * from "./top-shareholders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./locale/shareholders-en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Fthe-exchange%2Fmarket-information%2Fcompany%2F_SecuritySymbol%2Ftrading%2Ftop-shareholders.vue&locale=en&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./locale/shareholders-ar.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Fthe-exchange%2Fmarket-information%2Fcompany%2F_SecuritySymbol%2Ftrading%2Ftop-shareholders.vue&locale=ar&external"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InfoBox: require('/vercel/path0/components/InfoBox.vue').default})
